export const MinusIcon = ({ stroke, size }: { stroke: string, size?: number }) => {
    return <svg width={size || 16} height={size || 16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M3.33331 8H12.6666" stroke={stroke} strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
    </svg>

}